import React, { Component } from 'react';
import {Button} from 'reactstrap';
import { withCookies } from 'react-cookie';
import '../css/alum-style.css';
import './Verification.css'
import MainLogoBeta from '../art/images/jpg-as-logo-color-vertical-copy.jpg'


class EmailVerification extends Component {
    state = {
        isLoading: true,
        isAuthenticated: false,
        user: undefined,
        consent: false
    };

    constructor(props) {
        super(props);
        const {cookies} = props;
        this.state.csrfToken = cookies.get('XSRF-TOKEN');
        this.logout = this.logout.bind(this);
    }

    async componentDidMount() {
        const response = await fetch('/alumsum/reguser', {credentials: 'include'});
        const body = await response.text();
        if (body === '') {
            this.setState(({isAuthenticated: false}))
        } else {
            this.setState({isAuthenticated: true, user: JSON.parse(body), consent:JSON.parse(body).consent})
        }

        await fetch('/alumsum/users', {credentials: 'include'})
            .then(async response => response.json())
            .then(data => this.setState({ info: data })
            );

        this.setState({email: this.state.info[0].userEmail});
    }


    logout() {
        fetch('/alumsum/logout', {method: 'POST', credentials: 'include',
            headers: {'X-XSRF-TOKEN': this.state.csrfToken}}).then(res => res.json())
            .then(response => {
                console.log(response);
                window.location.href = response.logoutUrl + "?id_token_hint=" +
                    response.idToken + "&post_logout_redirect_uri=" + window.location.origin;
            });
    }

    render() {

        const note =
            <h2 className="welcomeUser2"> Check your email!</h2>
        const message =
            <h2 className="welcomeUser">We just sent a verification email to <strong>{this.state.email}</strong>. Check your email to continue setting up your account. It could be in your spam/junk folder!</h2>

        const buttonStyle = {
            backgroundColor: '#468674',
            padding: '1.35rem 0.85rem 0.75rem 0.85rem'
        };

        const button =
            <div className="buttonDiv">
                <Button className="homeButton" onClick={this.logout}>OK</Button>
            </div>;

        return (
            <div className="homeContainer">
                <div className="main-logo">
                    <img src={MainLogoBeta} alt="main logo" className="responsive" width="75px"
                         height="10px"/>
                </div>
                <form>
                    {note}
                    {message}
                    {button}
                </form>
            </div>
        );
    }
}
export default withCookies(EmailVerification);